import type { FigmaIconProps } from './types';

export const IconFigmaCheckmarkS = ({ size = 11, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.45931 2.04297C8.84978 1.6525 9.48284 1.65261 9.87337 2.04297C10.2639 2.43349 10.2639 3.06651 9.87337 3.45703L4.83236 8.49902C4.44194 8.88944 3.80884 8.88922 3.41829 8.49902L1.1263 6.20703C0.735778 5.81651 0.735778 5.18349 1.1263 4.79297C1.51683 4.40244 2.14984 4.40244 2.54036 4.79297L4.12435 6.37695L8.45931 2.04297Z"
      fill={color}
    />
  </svg>
);
